export type PreventableEvent = { preventDefault: VoidFunction }
/**
 * Хелпер на случай, если единственное, что нужно сделать с событием, это предотвратить действие по умолчанию
 * @param e
 */
export function preventDefaultHandle<Event extends PreventableEvent>(e: Event) {
  e.preventDefault()
}

export type StoppableEvent = { stopPropagation: VoidFunction }
/**
 * Хелпер на случай, если единственное, что нужно сделать с событием, это остановить его распространение
 * @param e
 */
export function stopPropagationHandler<Event extends StoppableEvent>(e: Event) {
  e.stopPropagation()
}
